export const groups = {
  groups: [
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'c3dbe77c-df93-4044-b721-d879548f79a9',
      extTargetingId: 'c3dbe77c-df93-4044-b721-d879548f79a9-extTargetingId',
      title: '2050 Yonge copy - DO NOT USE - .Mods Bev',
      originalTitle: 'Test Title',
      createdDate: '2022-10-19T06:42:54',
      updatedDate: '2022-10-19T06:42:54',
      startDate: '2021-05-09T00:00:00',
      endDate: '2221-05-10T23:59:59',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: '.Mods Bev',
          shortDescription: 'short',
          longDescription: 'long',
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20.Mods%20Bev_1.jpg',
          ],
          mediumImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20.Mods%20Bev_1-md.jpg',
          ],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {
        PROPERTY_1: '68a283e4-344e-4e3e-886d-979c9ac01698',
        PROPERTY_2: '491b6e2d-e87b-4feb-8f3b-7af4710fc7c3',
      },
      privateAttributes: {},
      storeIds: ['f58c34ac-7ee0-4d39-a663-ef5881b0a217'],
      groupId: '60997a3a60b20eb4a15d8de6',
      groupType: 'OPTION_GROUP',
      itemIds: [
        '60997a3960b20eb4a15d8cfe',
        '60997a3960b20eb4a15d8cf5',
        '60997a3960b20eb4a15d8d0a',
        '60997a3960b20eb4a15d8cf7',
        '60997a3960b20eb4a15d8d03',
        '60997a3960b20eb4a15d8d02',
        '60997a3960b20eb4a15d8d0e',
        '60997a3960b20eb4a15d8d05',
        '60997a3960b20eb4a15d8c91',
        '60997a3960b20eb4a15d8d06',
      ],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '60997a3960b20eb4a15d8d05',
          itemGuid: '05d176fa-ffa9-4c02-b16a-baf1558563b4',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
        {
          itemId: '60997a3960b20eb4a15d8d03',
          itemGuid: 'dd9b1aa2-4415-4612-b7b9-077b361bb854',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
        {
          itemId: '60997a3960b20eb4a15d8cf7',
          itemGuid: '309b83d8-7dd2-4496-90da-1b6c53bc8338',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
        {
          itemId: '60997a3960b20eb4a15d8d0a',
          itemGuid: 'b36f24f7-e5b4-4c96-9e22-b8f1fecfa906',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
        {
          itemId: '60997a3960b20eb4a15d8c91',
          itemGuid: '99c61994-1754-4dde-9447-a96512a9d6dc',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
        {
          itemId: '60997a3960b20eb4a15d8cfe',
          itemGuid: 'e7b60460-7abe-47ee-ad65-550e0d54df03',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
        {
          itemId: '60997a3960b20eb4a15d8d02',
          itemGuid: '1ec86a2f-9f8c-42ce-b6eb-137354c17a57',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
        {
          itemId: '60997a3960b20eb4a15d8d06',
          itemGuid: '52cf4da2-540c-4cdc-86ed-4112a2edd83a',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
        {
          itemId: '60997a3960b20eb4a15d8d0e',
          itemGuid: 'c3b1fcbe-010d-400f-80d7-cf2a92c4051e',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
        {
          itemId: '60997a3960b20eb4a15d8cf5',
          itemGuid: '7038861a-af0d-4f59-9787-fd59da41bc05',
          maxItemSelections: 0,
          price: 0,
          isDefault: false,
          displayRank: null,
        },
      ],
      storeInfos: [
        {
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/c/WOV2%20Test%20Store%20-%20DO%20NOT%20EDIT%20QA%20-%20Basic%20Menu-62133511_1.jpg',
          ],
          storeId: '040b41cb-cf0e-4f24-9f85-60527cd5122b',
          title: '(Only to test TOAST -Apple-Pay) AET Rush Store QE',
        },
        {
          smallImage: null,
          storeId: 'newteststoreid',
          title: 'test store',
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '4ab79269-f219-4585-a7be-ecb77c119a10#247',
      extTargetingId: '4ab79269-f219-4585-a7be-ecb77c119a10#247-extTargetingId',
      title: 'Balsamic Toast Store - Test - Sause opt',
      createdDate: '2022-12-30T10:05:53',
      updatedDate: '2022-12-30T10:05:53',
      startDate: '2022-12-29T10:05:53',
      endDate: '2222-12-30T10:05:53',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Sause opt',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Inactive',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['66955a44-3a27-4720-9878-918d502c788a'],
      groupId: '63aeb801e4b02633175815d0',
      groupType: 'OPTION_GROUP',
      itemIds: ['63aeb801e4b02633175815cf', '63aeb801e4b02633175815ce'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 1,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63aeb801e4b02633175815cf',
          itemGuid: '4095bab9-17a1-41ce-a44f-75849acace4f#113',
          maxItemSelections: null,
          price: 6000,
          isDefault: false,
          displayRank: 2,
        },
        {
          itemId: '63aeb801e4b02633175815ce',
          itemGuid: 'ab678076-c983-48f3-a795-dce921d477d7#112',
          maxItemSelections: null,
          price: 5000,
          isDefault: false,
          displayRank: 1,
        },
      ],
      storeInfos: [
        {
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/c/WOV2%20Test%20Store%20-%20DO%20NOT%20EDIT%20QA%20-%20Basic%20Menu-62133511_1.jpg',
          ],
          storeId: '040b41cb-cf0e-4f24-9f85-60527cd5122b',
          title: '(Only to test TOAST -Apple-Pay) AET Rush Store QE',
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '9820099d-8918-4ab6-b465-f2f5c2df678e#203',
      title: 'Balsamic Toast Store - Test - Select Size',
      createdDate: '2022-12-30T10:05:53',
      updatedDate: '2022-12-30T10:05:53',
      startDate: '2022-12-29T10:05:53',
      endDate: '2222-12-30T10:05:53',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Select Size',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['66955a44-3a27-4720-9878-918d502c788a'],
      groupId: '63aeb801e4b0263317581609',
      groupType: 'OPTION_GROUP',
      itemIds: [
        '63aeb801e4b0263317581608',
        '63aeb801e4b02633175815f2',
        '63aeb801e4b02633175815fd',
      ],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 10,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63aeb801e4b02633175815fd',
          itemGuid: '64bfef44-016d-4354-b6a4-865471a93a75#204',
          maxItemSelections: null,
          price: 3000,
          isDefault: false,
          displayRank: 1,
        },
        {
          itemId: '63aeb801e4b02633175815f2',
          itemGuid: '133ca2d0-d73a-41df-9acc-697041f69fde#206',
          maxItemSelections: null,
          price: 7000,
          isDefault: false,
          displayRank: 3,
        },
        {
          itemId: '63aeb801e4b0263317581608',
          itemGuid: '9ee90946-436a-4640-8215-3e57ce8e1d0f#205',
          maxItemSelections: null,
          price: 9500,
          isDefault: false,
          displayRank: 2,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '9820099d-8918-4ab6-b465-f2f5c2df678e#1693',
      title: 'Balsamic Toast Store - Test - Select Size',
      createdDate: '2022-12-30T10:05:53',
      updatedDate: '2022-12-30T10:05:53',
      startDate: '2022-12-29T10:05:53',
      endDate: '2222-12-30T10:05:53',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Select Size',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Inactive',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['66955a44-3a27-4720-9878-918d502c788a'],
      groupId: '63aeb801e4b0263317581643',
      groupType: 'OPTION_GROUP',
      itemIds: [
        '63aeb801e4b026331758162c',
        '63aeb801e4b0263317581637',
        '63aeb801e4b0263317581642',
      ],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 10,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63aeb801e4b0263317581637',
          itemGuid: '9ee90946-436a-4640-8215-3e57ce8e1d0f#1695',
          maxItemSelections: null,
          price: 9500,
          isDefault: false,
          displayRank: 2,
        },
        {
          itemId: '63aeb801e4b0263317581642',
          itemGuid: '64bfef44-016d-4354-b6a4-865471a93a75#1694',
          maxItemSelections: null,
          price: 3000,
          isDefault: false,
          displayRank: 1,
        },
        {
          itemId: '63aeb801e4b026331758162c',
          itemGuid: '133ca2d0-d73a-41df-9acc-697041f69fde#1696',
          maxItemSelections: null,
          price: 7000,
          isDefault: false,
          displayRank: 3,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '9820099d-8918-4ab6-b465-f2f5c2df678e#27',
      title: 'Balsamic Toast Store - Test - Select Size',
      createdDate: '2022-12-30T10:05:53',
      updatedDate: '2022-12-30T10:05:53',
      startDate: '2022-12-29T10:05:53',
      endDate: '2222-12-30T10:05:53',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Select Size',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['66955a44-3a27-4720-9878-918d502c788a'],
      groupId: '63aeb801e4b02633175815b6',
      groupType: 'OPTION_GROUP',
      itemIds: [
        '63aeb801e4b02633175815b5',
        '63aeb801e4b02633175815b4',
        '63aeb801e4b02633175815a9',
      ],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 10,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63aeb801e4b02633175815a9',
          itemGuid: '64bfef44-016d-4354-b6a4-865471a93a75#28',
          maxItemSelections: null,
          price: 3000,
          isDefault: false,
          displayRank: 1,
        },
        {
          itemId: '63aeb801e4b02633175815b5',
          itemGuid: '133ca2d0-d73a-41df-9acc-697041f69fde#30',
          maxItemSelections: null,
          price: 7000,
          isDefault: false,
          displayRank: 3,
        },
        {
          itemId: '63aeb801e4b02633175815b4',
          itemGuid: '9ee90946-436a-4640-8215-3e57ce8e1d0f#29',
          maxItemSelections: null,
          price: 9500,
          isDefault: false,
          displayRank: 2,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '38c3c70c-a09e-4800-8322-525a0148f73a#80',
      title: 'Balsamic Toast Store - Test - Select Veg',
      createdDate: '2022-12-30T10:05:53',
      updatedDate: '2022-12-30T10:05:53',
      startDate: '2022-12-29T10:05:53',
      endDate: '2222-12-30T10:05:53',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Select Veg',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['66955a44-3a27-4720-9878-918d502c788a'],
      groupId: '63aeb801e4b02633175815be',
      groupType: 'OPTION_GROUP',
      itemIds: [
        '63aeb801e4b02633175815bd',
        '63aeb801e4b02633175815b7',
        '63aeb801e4b02633175815bc',
      ],
      defaultSelectedItems: ['63aeb801e4b02633175815b7'],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 2,
      minItemSelections: 1,
      groupItemSettings: [
        {
          itemId: '63aeb801e4b02633175815b7',
          itemGuid: 'd2642824-f11b-4148-9627-1a80f502d184#82',
          maxItemSelections: null,
          price: 7010,
          isDefault: true,
          displayRank: 2,
        },
        {
          itemId: '63aeb801e4b02633175815bd',
          itemGuid: 'd2080607-c0d7-449f-b0bc-11f04badea40#83',
          maxItemSelections: null,
          price: 5750,
          isDefault: false,
          displayRank: 3,
        },
        {
          itemId: '63aeb801e4b02633175815bc',
          itemGuid: 'c8d2571a-012b-4136-8c6b-a69daf224add#81',
          maxItemSelections: null,
          price: 3500,
          isDefault: false,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '6a455a6a-61e9-463d-8a94-79ad9abfa031',
      extTargetingId: '6a455a6a-61e9-463d-8a94-79ad9abfa031-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy)',
      createdDate: '2022-12-21T18:28:10',
      updatedDate: '2022-12-21T18:28:10',
      startDate: '2022-12-20T18:28:10',
      endDate: '2222-12-21T18:28:10',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a3503ae4b07cb2445cb6de',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a3503ae4b07cb2445cb6dd', '63a3503ae4b07cb2445cb6d7'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a3503ae4b07cb2445cb6dd',
          itemGuid: '4ac2e8a9-6056-4c77-832c-9bccce103a61#1293',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
        {
          itemId: '63a3503ae4b07cb2445cb6d7',
          itemGuid: 'c2e008ea-8c2d-46d1-9d96-a453f2ebc73d#1298',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '4fe2dee0-4e7f-493e-9e60-b1be33386653',
      extTargetingId: '4fe2dee0-4e7f-493e-9e60-b1be33386653-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy)',
      createdDate: '2022-12-21T18:28:10',
      updatedDate: '2022-12-21T18:28:10',
      startDate: '2022-12-20T18:28:10',
      endDate: '2222-12-21T18:28:10',
      displayRank: 15,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a3503ae4b07cb2445cb84a',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a22c32e4b0764f5e6564dd', '63a22c32e4b0764f5e6564dc'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a22c32e4b0764f5e6564dc',
          itemGuid: '781f78e3-c08e-4f75-b877-9d2d5c1336de#63',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
        {
          itemId: '63a22c32e4b0764f5e6564dd',
          itemGuid: '3bb37808-c1fb-41e2-bf2a-d3eadfde0340#58',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: 'bfcbb12e-9be4-4359-838f-b6b3c9592370',
      extTargetingId: 'bfcbb12e-9be4-4359-838f-b6b3c9592370-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy)',
      createdDate: '2022-12-21T18:28:09',
      updatedDate: '2022-12-21T18:28:09',
      startDate: '2022-12-20T18:28:09',
      endDate: '2222-12-21T18:28:09',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a35039e4b07cb2445cb060',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a22c32e4b0764f5e6564dd', '63a22c32e4b0764f5e6564dc'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a22c32e4b0764f5e6564dc',
          itemGuid: '781f78e3-c08e-4f75-b877-9d2d5c1336de#63',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
        {
          itemId: '63a22c32e4b0764f5e6564dd',
          itemGuid: '3bb37808-c1fb-41e2-bf2a-d3eadfde0340#58',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '53ba5ab0-a8bf-440d-b9d1-e41cf6af202a',
      extTargetingId: '53ba5ab0-a8bf-440d-b9d1-e41cf6af202a-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy)',
      createdDate: '2022-12-21T18:28:10',
      updatedDate: '2022-12-21T18:28:10',
      startDate: '2022-12-20T18:28:10',
      endDate: '2222-12-21T18:28:10',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a3503ae4b07cb2445cb5d4',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a3503ae4b07cb2445cb5cd', '63a3503ae4b07cb2445cb5d3'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a3503ae4b07cb2445cb5d3',
          itemGuid: '642b9e69-19ed-468f-9b0e-8522be1eeb2e#1102',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
        {
          itemId: '63a3503ae4b07cb2445cb5cd',
          itemGuid: 'e3c701ad-352f-4c79-ba67-cda88e4380f2#1107',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '44c2c40e-0b44-4484-974a-081d50e66224',
      extTargetingId: '44c2c40e-0b44-4484-974a-081d50e66224-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy)',
      createdDate: '2022-12-21T18:28:10',
      updatedDate: '2022-12-21T18:28:10',
      startDate: '2022-12-20T18:28:10',
      endDate: '2222-12-21T18:28:10',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a3503ae4b07cb2445cb938',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a22c32e4b0764f5e6564dd', '63a22c32e4b0764f5e6564dc'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a22c32e4b0764f5e6564dc',
          itemGuid: '781f78e3-c08e-4f75-b877-9d2d5c1336de#63',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
        {
          itemId: '63a22c32e4b0764f5e6564dd',
          itemGuid: '3bb37808-c1fb-41e2-bf2a-d3eadfde0340#58',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '4a51a535-6599-4842-b387-6afd947481a0',
      extTargetingId: '4a51a535-6599-4842-b387-6afd947481a0-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy)',
      createdDate: '2022-12-21T18:28:09',
      updatedDate: '2022-12-21T18:28:09',
      startDate: '2022-12-20T18:28:09',
      endDate: '2222-12-21T18:28:09',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a35039e4b07cb2445cafd5',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a22c32e4b0764f5e6564dd', '63a22c32e4b0764f5e6564dc'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a22c32e4b0764f5e6564dc',
          itemGuid: '781f78e3-c08e-4f75-b877-9d2d5c1336de#63',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
        {
          itemId: '63a22c32e4b0764f5e6564dd',
          itemGuid: '3bb37808-c1fb-41e2-bf2a-d3eadfde0340#58',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '3bc19721-a4fa-4744-83b5-ce7b5d32ea8a',
      extTargetingId: '3bc19721-a4fa-4744-83b5-ce7b5d32ea8a-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy) (Deep Copy)',
      createdDate: '2022-12-21T18:28:10',
      updatedDate: '2022-12-21T18:28:10',
      startDate: '2022-12-20T18:28:10',
      endDate: '2222-12-21T18:28:10',
      displayRank: 184,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy) (Deep Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a3503ae4b07cb2445cb849',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a3503ae4b07cb2445cb848', '63a3503ae4b07cb2445cb842'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a3503ae4b07cb2445cb842',
          itemGuid: '1254c325-1dc2-4dd2-bb9e-f53101e50cb0#1403',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
        {
          itemId: '63a3503ae4b07cb2445cb848',
          itemGuid: '3a03a50f-4f6b-4d1c-9fe8-6c89d6e416eb#1398',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: 'eb063e3a-508c-4657-9ac2-a617f0da6985',
      extTargetingId: 'eb063e3a-508c-4657-9ac2-a617f0da6985-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy) (Deep Copy)',
      createdDate: '2022-12-21T18:28:09',
      updatedDate: '2022-12-21T18:28:09',
      startDate: '2022-12-20T18:28:09',
      endDate: '2222-12-21T18:28:09',
      displayRank: 177,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy) (Deep Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a35039e4b07cb2445cb2d7',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a35039e4b07cb2445cb2d0', '63a35039e4b07cb2445cb2d6'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a35039e4b07cb2445cb2d0',
          itemGuid: 'da6c7a44-0ab3-44d5-94ad-71aa5b8baff4#1358',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
        {
          itemId: '63a35039e4b07cb2445cb2d6',
          itemGuid: '6e063207-134c-459a-b3cd-e34b2147d83b#1363',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '8a44e508-58c4-45ae-b84e-70058aad5f47',
      extTargetingId: '8a44e508-58c4-45ae-b84e-70058aad5f47-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy) (Deep Copy)',
      createdDate: '2022-12-21T18:28:10',
      updatedDate: '2022-12-21T18:28:10',
      startDate: '2022-12-20T18:28:10',
      endDate: '2222-12-21T18:28:10',
      displayRank: 215,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy) (Deep Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a3503ae4b07cb2445cb674',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a3503ae4b07cb2445cb673', '63a3503ae4b07cb2445cb66d'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a3503ae4b07cb2445cb673',
          itemGuid: 'ed5f1018-1475-49a1-937e-4a53e0e69a70#1688',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
        {
          itemId: '63a3503ae4b07cb2445cb66d',
          itemGuid: 'c501bd5f-276e-480d-932d-c76f219f999b#1683',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '63e2d139-e395-4c86-9925-38aeeeab29d7',
      extTargetingId: '63e2d139-e395-4c86-9925-38aeeeab29d7-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Copy) (Deep Copy)',
      createdDate: '2022-12-21T18:28:10',
      updatedDate: '2022-12-21T18:28:10',
      startDate: '2022-12-20T18:28:10',
      endDate: '2222-12-21T18:28:10',
      displayRank: 155,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Copy) (Deep Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a3503ae4b07cb2445cb775',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a3503ae4b07cb2445cb76e', '63a3503ae4b07cb2445cb774'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a3503ae4b07cb2445cb774',
          itemGuid: '70d630d1-6e66-4b03-85dc-fae3a4480cd4#1163',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
        {
          itemId: '63a3503ae4b07cb2445cb76e',
          itemGuid: 'ce740276-a3ce-456f-9580-20f94b78889c#1158',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: 'df65a376-11c1-485f-a70d-2cb14743736d',
      extTargetingId: 'df65a376-11c1-485f-a70d-2cb14743736d-extTargetingId',
      title: 'DEV TEAM - TOAST - Dessert (Deep Copy)',
      createdDate: '2022-12-21T18:28:09',
      updatedDate: '2022-12-21T18:28:09',
      startDate: '2022-12-20T18:28:09',
      endDate: '2222-12-21T18:28:09',
      displayRank: 21,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dessert (Deep Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a35039e4b07cb2445cb1b0',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a35039e4b07cb2445cb1af', '63a35039e4b07cb2445cb1a9'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a35039e4b07cb2445cb1af',
          itemGuid: 'feaa59e9-b492-47fa-a0bc-f9ffa2b0c276#356',
          maxItemSelections: 0,
          price: 6990,
          isDefault: null,
          displayRank: 1,
        },
        {
          itemId: '63a35039e4b07cb2445cb1a9',
          itemGuid: '9578ce09-de89-4bc3-a510-4d21167ca9a7#361',
          maxItemSelections: 0,
          price: 4500,
          isDefault: null,
          displayRank: 2,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '58bca24f-f43f-40c3-843b-d5166270c312',
      extTargetingId: '58bca24f-f43f-40c3-843b-d5166270c312-extTargetingId',
      title: 'DEV TEAM - TOAST - Dinner Menu (Deep Copy)',
      createdDate: '2022-12-21T18:28:10',
      updatedDate: '2022-12-21T18:28:10',
      startDate: '2022-12-20T18:28:10',
      endDate: '2222-12-21T18:28:10',
      displayRank: 107,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dinner Menu (Deep Copy)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a3503ae4b07cb2445cb7a2',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a3503ae4b07cb2445cb7a1'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a3503ae4b07cb2445cb7a1',
          itemGuid: '03a53c28-ab0e-4e04-9831-0fa443b64e04#693',
          maxItemSelections: 0,
          price: 20000,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: 'cda312e1-64c4-467a-a63e-80207933429c',
      extTargetingId: 'cda312e1-64c4-467a-a63e-80207933429c-extTargetingId',
      title: 'DEV TEAM - TOAST - Dinners (Scenario N)',
      createdDate: '2022-12-20T21:42:10',
      updatedDate: '2022-12-20T21:42:10',
      startDate: '2022-12-19T21:42:10',
      endDate: '2222-12-20T21:42:10',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dinners (Scenario N)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a22c32e4b0764f5e656446',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a22c32e4b0764f5e656445'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a22c32e4b0764f5e656445',
          itemGuid: '81c2610c-9bb1-48d3-aea3-849711593041#1',
          maxItemSelections: 0,
          price: 9990,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '2b3a9731-2029-444b-9cac-31cbbab32297',
      extTargetingId: '2b3a9731-2029-444b-9cac-31cbbab32297-extTargetingId',
      title: 'DEV TEAM - TOAST - Dinners (Scenario N)',
      createdDate: '2022-12-21T18:28:10',
      updatedDate: '2022-12-21T18:28:10',
      startDate: '2022-12-20T18:28:10',
      endDate: '2222-12-21T18:28:10',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dinners (Scenario N)',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a3503ae4b07cb2445cb572',
      groupType: 'CATALOG_GROUP',
      itemIds: ['63a3503ae4b07cb2445cb571'],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 0,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a3503ae4b07cb2445cb571',
          itemGuid: 'e0f38665-735b-4b67-945e-def44be87fa6#749',
          maxItemSelections: 0,
          price: 9990,
          isDefault: null,
          displayRank: 1,
        },
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '1611ebff-eccb-4a51-a5e9-77f6ba5a800c#472',
      title: 'DEV TEAM - TOAST - Dressing',
      createdDate: '2022-12-21T18:28:09',
      updatedDate: '2022-12-21T18:28:09',
      startDate: '2022-12-20T18:28:09',
      endDate: '2222-12-21T18:28:09',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Dressing',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Inactive',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['1a972340-2b41-42d7-8dd0-ca7244a4c101'],
      groupId: '63a35039e4b07cb2445cb0f8',
      groupType: 'OPTION_GROUP',
      itemIds: [
        '63a35039e4b07cb2445cb0f5',
        '63a35039e4b07cb2445cb0f6',
        '63a35039e4b07cb2445cb0f7',
      ],
      defaultSelectedItems: [],
      mandatoryItems: [],
      optionGroupIds: [],
      subGroupIds: [],
      selectionMandatory: false,
      selectionType: 'MULTI_SELECT',
      inheritParentOptions: false,
      maxItemSelections: 1,
      minItemSelections: 0,
      groupItemSettings: [
        {
          itemId: '63a35039e4b07cb2445cb0f6',
          itemGuid: '1d82b47f-ed4c-46d3-b866-ec44c49da843#475',
          maxItemSelections: null,
          price: 0,
          isDefault: false,
          displayRank: 3,
        },
        {
          itemId: '63a35039e4b07cb2445cb0f5',
          itemGuid: 'bb453074-a4e2-45dc-97c6-32f8168c1c0a#474',
          maxItemSelections: null,
          price: 0,
          isDefault: false,
          displayRank: 2,
        },
        {
          itemId: '63a35039e4b07cb2445cb0f7',
          itemGuid: '288e7a85-06ba-41aa-829e-81a73f443c61#473',
          maxItemSelections: null,
          price: 0,
          isDefault: false,
          displayRank: 1,
        },
      ],
    },
  ],
  paging: { total: 6521, count: 1000, totalPages: 7, currentPage: 0 },
};
